import { CommonData } from '../common_schema'

export const sqlData: CommonData[] = [
  {
    name: 'Parse Duration(p99)',
    mean: 'P99_parse_duration:total.values.mean',
    std: 'P99_parse_duration:total.values.std',
    location: 'Performance Overview --> Parse Duration'
  },
  {
    name: 'Compile Duration(p99)',
    mean: 'P99_compile_duration:total.values.mean',
    std: 'P99_compile_duration:total.values.std',
    location: 'Performance Overview --> Compile Duration'
  },
  {
    name: 'KV errors(summary for all types)',
    mean: 'QPS_withError:total.values.mean',
    std: 'QPS_withError:total.values.std',
    location: `TiDB-Details --> KV errors --> TiClient Region Error OPS +<br />
    TiDB-Details --> KV errors --> KV Backoff OPS +<br />
    TiDB-Details --> KV errors --> Lock Resolve OPS +<br />
    TiDB-Details --> KV errors --> Other Errors OPS +`
  }
]
